<template>
  <section class="section" id="orders-panel">
    <div class="container">
      <b-loading
        :is-full-page="true"
        :active="isLoading"
        :can-cancel="false"
      ></b-loading>

      <orders-title
        :ordersQty="ordersReverse.length"
        :storeId="storeBeingManaged._id"
        :storeName="storeBeingManaged.storeInfo.name"
        @update-dates="updateDates"
        @update-store="updateStore"
        @create-order="isNewOrderModalOpen = true"
        @get-orders="getOrders"
        @download-orders-report="downloadOrdersReport"
      />

      <h2 v-if="ordersReverse.length === 0" class="subtitle has-text-centered">
        {{ $t("orders.noOrdersAtThisTime") }}
      </h2>

      <orders-table
        v-else
        :orders="ordersReverse"
        @open-order-details="openOrderDetails"
      />

      <b-modal full-screen :active.sync="isNewOrderModalOpen">
        <new-order-modal />
      </b-modal>

      <b-modal :active.sync="isOrderDetailsModalActive">
        <order-details-modal :order="order" />
      </b-modal>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import { mask } from "../../mixins/mask";
import ordersTitle from "./OrdersTitle";
import newOrderModal from "./NewOrderModal";
import orderDetailsModal from "./OrderDetailsModal";
import ordersTable from "./orders-table/OrdersTable";

export default {
  mixins: [common, mask],

  components: {
    ordersTitle,
    newOrderModal,
    orderDetailsModal,
    ordersTable
  },

  data() {
    return {
      isLoading: false,
      dates: [],
      store: undefined,
      storeName: null,
      isNewOrderModalOpen: false,
      isOrderDetailsModalActive: false,
      order: {}
    };
  },

  computed: {
    ...mapGetters(["storeBeingManaged", "ordersReverse", "permissions"])
  },

  methods: {
    getOrders() {
      this.isLoading = true;
      this.$store
        .dispatch("getOrders", {
          storeId: this.store,
          dates: this.dates
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    downloadOrdersReport() {
      this.isLoading = true;
      this.$store
        .dispatch("downloadOrdersReport", {
          storeName: this.storeName,
          storeId: this.store,
          dates: this.dates
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    updateDates(dates) {
      this.dates[0] = dates
        ? this.moment(dates[0]).format("YYYY-MM-DD")
        : this.moment().format("YYYY-MM-DD");

      this.dates[1] = dates
        ? this.moment(dates[1]).format("YYYY-MM-DD")
        : this.moment().format("YYYY-MM-DD");
    },

    updateStore(store) {
      this.store = store ? store.split("|")[0] : "";
      this.storeName = store
        ? store.split("|")[1]
        : this.$t("orders.allStores");
    },

    openOrderDetails(orderId) {
      this.isLoading = true;
      this.$store
        .dispatch("getOrderDetails", orderId)
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.order = res.data.payload.order;
            this.isOrderDetailsModalActive = true;
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  mounted() {
    this.updateDates();
    this.getOrders();
  },

  created() {
    this.store = this.storeBeingManaged._id;
    this.storeName = this.storeBeingManaged.storeInfo.name;
  }
};
</script>

<style scoped>
#orders-panel {
  margin-top: 3rem;
  min-height: 94vh;
  padding: 2rem 1rem;
  background-color: hsl(0, 0%, 96%);
}
</style>
